import Constants from '@/Constants';
import React, { useState } from 'react';
import './style.scss';

interface Props {
    src?: string;
    alt?: string;
    size?: number;
}

const PersonImage: React.FC<Props> = ({ alt = '', src, size = 55 }) => {
    const [hasImageError, setHasImageError] = useState<boolean>(false);

    return (
        <div className="person-image-container" style={{ width: size, height: size }}>
            {src && !hasImageError ? (
                <img alt={alt} className="person-image-container__image" onError={() => setHasImageError(true)} src={src} />
            ) : (
                <i className="material-icons-outlined" style={{ fontSize: size * 0.6 }}>
                    {Constants.icons.PERSON}
                </i>
            )}
        </div>
    );
};

export default PersonImage;
